const datasetEn = {
	datasetTable: 'Dataset',
	name: 'Name',
	datasetEditForm: 'Dataset',
	basic: 'Basic',
	table_name: 'Table Name',
	description: 'Description',
	fields: 'Fields',
	role: 'Role',
	type: 'Type',
	keyFields: 'Key fields',
	valueFields: 'Value fields',
	userGroup: 'User Group'
};

export default datasetEn;
